import React, { useState, useEffect, FormEvent } from "react";
import DeviceSelectionScreen from "./DeviceSelectionScreen/DeviceSelectionScreen";
import IntroContainer from "../IntroContainer/IntroContainer";
import MediaErrorSnackbar from "./MediaErrorSnackbar/MediaErrorSnackbar";
import RoomNameScreen from "./RoomNameScreen/RoomNameScreen";
import { useAppState } from "../../state";
import { useParams } from "react-router-dom";
import useVideoContext from "../../hooks/useVideoContext/useVideoContext";
import { createNewRoom } from "../../state/APIs";
import { getDisplayNameEmail } from "../../utils";

export enum Steps {
  roomNameStep,
  deviceSelectionStep
}

export default function PreJoinScreens() {
  const { user } = useAppState();
  const { getAudioAndVideoTracks } = useVideoContext();
  const { urlRoomName } = useParams();
  const [step, setStep] = useState<Steps | null>(null);
  const [roomName, setRoomName] = useState<string>("");

  const [mediaError, setMediaError] = useState<Error>();

  useEffect(() => {
    if (urlRoomName) {
      setRoomName(urlRoomName);
      if (user?.displayName) {
        setStep(Steps.deviceSelectionStep);
      }
    }

    if (!urlRoomName) {
      setRoomName("");
      setStep(Steps.roomNameStep);
    }
  }, [user, urlRoomName]);

  useEffect(() => {
    if (step === Steps.deviceSelectionStep && !mediaError) {
      getAudioAndVideoTracks().catch(error => {
        console.log("Error acquiring local media:");
        console.dir(error);
        setMediaError(error);
      });
    }

    if (step === Steps.roomNameStep) {
      setRoomName("");
      window.history.pushState(null, "", "/");
    }
  }, [getAudioAndVideoTracks, step, mediaError]);

  const onJoinExistingRoom = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    window.history.replaceState(
      null,
      "",
      window.encodeURI(`/room/${roomName}${window.location.search || ""}`)
    );

    setStep(Steps.deviceSelectionStep);
  };

  const onCreateNewRoom = () => {
    return createNewRoom()
      .then(_roomName => {
        window.history.pushState(null, "", `/room/${_roomName}`);
        setRoomName(_roomName);
        setStep(Steps.deviceSelectionStep);
      })
      .catch(error => {
        console.error(error);
      });
  };

  return (
    <IntroContainer className="PreJoinScreens">
      <MediaErrorSnackbar error={mediaError} />
      {step === Steps.roomNameStep && (
        <RoomNameScreen
          roomName={roomName}
          setRoomName={setRoomName}
          onJoinExistingRoom={onJoinExistingRoom}
          onCreateNewRoom={onCreateNewRoom}
        />
      )}

      {step === Steps.deviceSelectionStep && (
        <DeviceSelectionScreen
          name={getDisplayNameEmail(user)}
          roomName={roomName}
          setStep={setStep}
        />
      )}
    </IntroContainer>
  );
}
